
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/foto-izbor",
      function () {
        return require("private-next-pages/foto-izbor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/foto-izbor"])
      });
    }
  